export default __webpack_public_path__ + "images/rosabandet/featured-ribbon.png";